export enum ActionType {
  ACCEPT_QUOTE = 'jobs.acceptQuote',
  DECLINE_JOB = 'jobs.declineJob',
  DUPLICATE_JOB = 'jobs.duplicateJob',
}
